import { render, staticRenderFns } from "./CFormRating.vue?vue&type=template&id=17fbd8f4&scoped=true&"
import script from "./CFormRating.vue?vue&type=script&lang=js&"
export * from "./CFormRating.vue?vue&type=script&lang=js&"
import style0 from "./CFormRating.vue?vue&type=style&index=0&id=17fbd8f4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17fbd8f4",
  null
  
)

export default component.exports